import { render, staticRenderFns } from "./ProfileActivation.vue?vue&type=template&id=3370a4e8&scoped=true&"
import script from "./ProfileActivation.vue?vue&type=script&lang=ts&"
export * from "./ProfileActivation.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileActivation.vue?vue&type=style&index=0&id=3370a4e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3370a4e8",
  null
  
)

export default component.exports